import React, { useEffect } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";

import Header from "../Header/Header";
import AdminNav from "../../components/AdminNav/AdminNav";
import { useState } from "react";
import ManageBooks from "../ManageBooks/ManageBooks";
import ManageProduct from "../../components/ManageProduct/ManageProduct"
import { Table } from 'react-bootstrap';


const Admin = () => {

  const [toggle, setToggle] = useState(true);

  const [manageProduct, setManageProduct] = useState([])

  
  const [deleteProduct, setDeleteProduct] = useState(false)

  useEffect(() => {
      fetch('https://cryptic-plains-44743.herokuapp.com/books')
          .then(res => res.json())
          .then(data => setManageProduct(data))
  }, [deleteProduct])




  //add book


  const { register, handleSubmit, watch, formState: { errors } } = useForm();

  const [imageUrl, setImageUrl] = useState(null);
  const onSubmit = data => {

    const bookData ={

      name: data.name,
      author: data.author,
      publisher: data.publisher,
      price: data.price,
      imageUrl: imageUrl
    }

    const url = `https://cryptic-plains-44743.herokuapp.com//addBook`
    console.log(bookData)

    fetch(url,{
      method : 'POST',
      headers: {
        'content-type' : 'application/json'
      },
      body : JSON.stringify(bookData),

    })
    .then(res => console.log("server side response", res))

  };




  
// image upload

const handleImgUpload = event => {
  
  console.log(event.target.files[0])

  const imgData = new FormData();
  imgData.set('key', 'c3913b84aaff982ae826997c54227f96' );
  imgData.append('image', event.target.files[0])

  axios.post('https://api.imgbb.com/1/upload', 
  imgData
  )
  .then(function (response) {
    setImageUrl(response.data.data.display_url);
  })
  .catch(function (error) {
    console.log(error);
  });


}


    // delete books







  


  const deleteProducts = (id) => {

    fetch(`https://cryptic-plains-44743.herokuapp.com//deleteProducts/${id}`,{
         method: 'DELETE'
    })
        .then(res => res.json())
        .then(data => {           
          if(data){
            setDeleteProduct(data)
          }

        })
  }














  return (
  

<div className="container"> 
<Header></Header>
<div className="container d-flex">

<div className="mt-3 btn-toggle" style={{ backgroundColor: '#16a738', width: '200px', height: '500px', color: 'white' }}>
    <p onClick={() => setToggle(true)} style={{ margin: '30px 40px' }}>Manage Books</p>
    <p onClick={() => setToggle(false)} style={{ margin: '30px 40px' }}>Add Book</p>
</div>




{
    toggle ?


    <div className="ml-3 mt-3" style={{ border: '1px solid lightgray', width: '80%' }}>
                        <h2 className="mt-3 mb-3 ml-3">Mange Books</h2>


                        <Table responsive="sm">
                            <thead >
                                <tr>
                                    <th>Book Name</th>
                                    <th>Quantity</th>
                                    <th>Price</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                            {

                                 manageProduct.map(pd => <ManageBooks deleteProducts={deleteProducts} pd={pd}></ManageBooks>)
                             }

                            </tbody>
                        </Table>

                    </div>


     :

                 <div className="ml-3 mt-3" style={{ backgroundColor: '#F4FCFB', width: '80%' }}>
                        <h1 className="mt-5 ml-3">Add Product</h1>

                        <div className='ml-5'>
                                  

                                  
          <form onSubmit={handleSubmit(onSubmit)}>





<label htmlFor="name">Book Name</label>
<input  type="text" name="name" placeholder="Book Name"  {...register("name")}  />

<br/>
<br/>
<label htmlFor="author">Author</label>
<input type="text" name="author" placeholder="Author"  {...register("author")} />
<br/>
<br/>
<label htmlFor="author">Publisher</label>
<input type="text" name="publisher" placeholder="publisher"  {...register("publisher")} />
<br/>
<br/>
<label htmlFor="price">Price</label>
<input type="number" name="price" placeholder="Price" {...register("price")} />
<br/>
<br/>
<input type="File" name="file" onChange={ handleImgUpload }/>
<br/>
<br/>
<button type="submit">Add Book</button>



</form>
                          
                        </div>
                    </div>

}

</div>

</div>
   


  );
};

export default Admin;
